import { render, staticRenderFns } from "./assignees.vue?vue&type=template&id=29676250&"
import script from "./assignees.vue?vue&type=script&lang=js&"
export * from "./assignees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports